// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 334 ? "5e0221ee" : chunkId) + "." + {"334":"29c5328e5e9083b3","604":"3efa4368d6cb98a3"}[chunkId] + ".js";
};